import React from "react"
import PropTypes from "prop-types"
import styles from "./styles.js"
import CheckIcon from "@material-ui/icons/Check"
import { componentOptions } from "../../constants/componentOptions"
import WifiOffIcon from "@material-ui/icons/WifiOff"
import CloseIcon from "@material-ui/icons/Close"
import Button from "@material-ui/core/Button"
const SelectComponent = ({
	isMaster,
	masterComponentScanned,
	nodeComponentScanned,
	nodeDetails,
	masterUuid,
	nodeLocIdFromUrl,
	componentListSelectionHandler,
}) => {
	const styling = styles()
	const controller = isMaster
		? masterComponentScanned[masterUuid]
		: nodeComponentScanned[nodeDetails[masterUuid][nodeLocIdFromUrl].uuid]

	return (
		<div className={styling.componentSelectionMenuContainer}>
			<ul className={styling.componentSelectionList}>
				{componentOptions.map((option, index) => {
					return (
						(isMaster ? option.isMaster : !option.isMaster) &&
						option.enabled && (
							<li
								className={styling.componentEnabled}
								key={index}
								onClick={() => componentListSelectionHandler(option)}
							>
								<div className={styling.componentScannedStatusIcon}>
									{controller && controller[option.urlName] ? (
										controller[option.urlName].status === "success" ? (
											<CheckIcon className={styling.icon} />
										) : controller[option.urlName].status === "pending" ? (
											<WifiOffIcon color={"error"} className={styling.icon} />
										) : (
											<CloseIcon color={"error"} className={styling.icon} />
										)
									) : (
										""
									)}
								</div>
								<Button variant="contained" color="primary" size="large" className={styling.componentOptionButton}>
									{option.name.toUpperCase()}
								</Button>
							</li>
						)
					)
				})}
			</ul>
		</div>
	)
}

SelectComponent.propTypes = {
	isMaster: PropTypes.bool.isRequired,
	masterComponentScanned: PropTypes.object.isRequired,
	nodeComponentScanned: PropTypes.object.isRequired,
	nodeDetails: PropTypes.object.isRequired,
	masterUuid: PropTypes.string.isRequired,
	nodeLocIdFromUrl: PropTypes.string.isRequired,
	handleNodeComponentSelection: PropTypes.func.isRequired,
	setDeviceIdEntryMethod: PropTypes.func.isRequired,
	setNodeIdReplacement: PropTypes.func.isRequired,
	componentListSelectionHandler: PropTypes.func.isRequired,
}

export default SelectComponent
